import React from "react";
import PropTypes from "prop-types";
import archiveInstallationRequestMutation from "../graphql/mutations/archiveInstallationRequest.graphql";
import { errorAlert, successAlert } from "../../common/actions/alertActions";
import { useDispatch } from "react-redux";
import { useMutation } from "../../common/api/GraphQLClient";
import { trans } from "../../../translations";

ArchiveRequestAction.propTypes = {
  uuid: PropTypes.string.isRequired,
  onDelete: PropTypes.func,
};

export default function ArchiveRequestAction({ uuid, onDelete = null }) {
  const dispatch = useDispatch();
  const [deleteRequest, { loading }] = useMutation(
    archiveInstallationRequestMutation,
  );

  const onClick = () => {
    if (
      !window.confirm(trans(`pages.installations.actions.delete.alert.message`))
    ) {
      return;
    }

    deleteRequest({ variables: { uuid } })
      .then(() => {
        dispatch(
          successAlert(
            trans(`pages.installations.actions.delete.alert.success`),
          ),
        );
        if (null !== onDelete) {
          onDelete(uuid);
        }
      })
      .catch(() => {
        dispatch(
          errorAlert(trans(`pages.installations.actions.delete.alert.error`)),
        );
      });
  };

  return (
    <button
      type="button"
      className="action"
      onClick={onClick}
      disabled={loading}
      title={trans(`pages.installations.actions.delete.label`)}
    >
      <i className="fa-solid fa-trash" aria-hidden="true" />
    </button>
  );
}
